import { computed, signal } from '@angular/core';
export class ComplexDialogTemplateConfigurationService {
  complexDialogConfigSignal = signal({});
  dialogConfig = computed(() => this.complexDialogConfigSignal());
  customDataSignal = signal({});
  customData = computed(() => this.customDataSignal());
  loadingSignal = signal(false);
  loading = computed(() => this.loadingSignal());
  disableAcceptButtonSignal = signal(undefined);
  disableAcceptButton = computed(() => this.disableAcceptButtonSignal());
  outputDataSignal = signal(undefined);
  outputData = computed(() => this.outputDataSignal());
  constructor(complexDialogConfig) {
    this.setComplexDialogConfig(complexDialogConfig);
  }
  setComplexDialogConfig(complexDialogConfig) {
    this.complexDialogConfigSignal.set({
      ...complexDialogConfig
    });
  }
  /**
   * For setting customData to be used in the dialog's header or footer templates
   * @param customData
   */
  setCustomData(customData) {
    this.customDataSignal.set(customData);
  }
  /**
   * For setting a loading state to be used in the dialog's header or footer templates
   * @param isLoading
   */
  setLoading(isLoading) {
    this.loadingSignal.set(isLoading);
  }
  /**
   * For setting the accept button disabled state to be used in the dialog's header or footer templates
   * @param show
   */
  setDisableAcceptButton(show) {
    this.disableAcceptButtonSignal.set(show);
  }
  /**
   * For setting output Data that you can receive in onClose
   */
  setOutputData(outPutData) {
    this.outputDataSignal.set(outPutData);
  }
}
